import React from 'react'

const FormSuspension = () => {
    return (
        <div>
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="alert alert-warning text-center" role="alert">
                    <strong>Form is suspended</strong>
                </div>
            </div>
        </div>
    )
}

export default FormSuspension
